export default {
  strict: true,
  namespaced: true,
  state: {
    reservationText: '',
    reservationNumber: '',
    roundTripPaymentError: false
  },
  mutations: {
    setThankYouData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/thankyou.js